import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { ReactComponent as IconeChatbot } from "../../../../assets/icons/chatbot.svg";
import * as S from "./styles";

const URL_IA =
  "https://auth.draiven.io/login?state=hKFo2SB3V3ZmUllMbkJtcmpvdHNOSTJVVlNBcVVhWWg3UkE1T6FupWxvZ2luo3RpZNkgZUtkcDViT19xZHVzck41OHVVOGY4YUtfUVh4NDFvdGWjY2lk2SBvcnhHODVpYUxxYzVJU0dUQjlWV0VZVXA1U3Njb3JGcQ&client=orxG85iaLqc5ISGTB9VWEYUp5SscorFq&protocol=oauth2&scope=openid%20profile%20email%20offline_access&response_type=code&redirect_uri=https%3A%2F%2Fai.sifat.com.br%2Fapi%2Fauth%2Fcallback&audience=https%3A%2F%2Fdev-k0p4k8ca1mjx8av4.us.auth0.com%2Fapi%2Fv2%2F&nonce=b49_57OHQ3fJ3NfJKSJ2BqpfewGDDotyCqEgLzHbG5o&code_challenge_method=S256&code_challenge=QRxHq2APRdglxy7yYUPrCS00Vy9YGqfxco6M9tm6kaM";

// A IA abre em nova guia; o destino do chatbot ainda não existe, então ele só avisa que não está integrado.
export default function BotaoAssistente({ tipo, compacto = false }) {
  const { t: tAssistenteIA } = useTranslation("assistenteIA");
  const ehIA = tipo === "ia";

  const aoClicar = () => {
    if (ehIA) {
      window.open(URL_IA, "_blank", "noopener,noreferrer");
      return;
    }

    toast.info(tAssistenteIA("messages.chatbotNotIntegrated"));
  };

  const botao = (
    <S.Botao
      type="button"
      $compacto={compacto}
      aria-label={tAssistenteIA(ehIA ? "buttons.openIa" : "buttons.openChatbot")}
      onClick={aoClicar}
    >
      {ehIA ? (
        <>
          <S.Brilhos aria-hidden="true" />
          <S.TextoIA aria-hidden="true">{tAssistenteIA("labels.ia")}</S.TextoIA>
        </>
      ) : (
        <IconeChatbot aria-hidden="true" />
      )}
    </S.Botao>
  );

  if (!ehIA) return botao;

  return (
    <Tooltip title={tAssistenteIA("tooltips.ia")} placement="bottom" arrow>
      {botao}
    </Tooltip>
  );
}
